import React from "react";

export default function TrashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.99996 5.83333C4.76784 5.83333 4.54624 5.93014 4.38853 6.10045C4.23081 6.27077 4.15128 6.49914 4.16908 6.73058L4.82486 15.2557C4.95845 16.9923 6.40659 18.3333 8.14837 18.3333H11.8516C13.5933 18.3333 15.0415 16.9923 15.1751 15.2556L15.8308 6.73058C15.8486 6.49914 15.7691 6.27077 15.6114 6.10045C15.4537 5.93014 15.2321 5.83333 15 5.83333H4.99996Z"
        fill="#BD2B23"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3334 2.5L15.8334 2.50001C16.2936 2.50001 16.6667 2.8731 16.6667 3.33334C16.6667 3.79358 16.2936 4.16667 15.8334 4.16667H4.16671C3.70647 4.16667 3.33337 3.79358 3.33337 3.33334C3.33337 2.8731 3.70647 2.50001 4.16671 2.50001H6.66671V2.5L8.20403 2.5C8.52683 2.5 8.82827 2.33867 9.00733 2.07009C9.47958 1.36171 10.5205 1.36171 10.9928 2.07009C11.1718 2.33867 11.4733 2.5 11.7961 2.5L13.3334 2.5Z"
        fill="#BD2B23"
      />
    </svg>
  );
};
